import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=eb233dc0&scoped=true"
import script from "./AgentDetail.vue?vue&type=script&lang=js"
export * from "./AgentDetail.vue?vue&type=script&lang=js"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=eb233dc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb233dc0",
  null
  
)

export default component.exports